<template>
	<section>
		<div class="inner-chat-menu">
			<el-dropdown placement="bottom" trigger="click" :popper-append-to-body="false" @command="handleGroupCommands">
				<i class="el-icon-setting" style="margin-right: 8px"></i>
				<el-dropdown-menu slot="dropdown" :class="`inner-chat-menu-dropdown`">
					<el-dropdown-item command="showManageGroup">Manage Group</el-dropdown-item>
					<el-dropdown-item v-if="groupAdmin" command="manageGroupDelete">Delete Group</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>

		<el-dialog :class="`merge-dialog`" title="Manage Group" :visible.sync="manageGroup.show" :modal="false">
			<div slot="title" :class="`d-flex justify-content-between align-items-center`">
				Manage Group
			</div>
			<div class="group-class">
				<label for="group-name">Group Name</label>
				<el-input class="mb-3" name="group-name" :disabled="!groupAdmin" v-model="manageGroup.details.name"></el-input>
				<label for="group-admins"  v-if="groupAdmin">Group Administrators</label>
				<el-select
				 	v-if="groupAdmin"
					v-model="manageGroup.details.group_admins"
					multiple
					name="group-admins"
					collapse-tags
					value-key="id"
					:class="`w-100 mb-3`"
					placeholder="Select">
					<el-option
						v-for="member in members"
						:key="member.id"
						:label="member.full_name"
						:value="member.id">
					</el-option>
				</el-select>
				<label for="group-members">Group Members</label>
				<el-select
					v-if="privateGroupOptions"
					v-model="manageGroup.details.group_members"
					multiple
					name="group-members"
					collapse-tags
					value-key="id"
					:class="`w-100`"
					placeholder="Select">
					<el-option
						v-for="member in members"
						:key="member.id"
						:label="member.full_name"
						:value="member">
					</el-option>
				</el-select>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="manageGroup.show = false">Cancel</el-button>
				<el-button type="success" @click="manage()">Ok</el-button>
			</span>
		</el-dialog>

	</section>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'InnerChatToolBox',
  components: {
  },
  props: {
		currentChat: {
			required: true
		}
  },
  data() {
    return {
			manageGroup: {
				show: false,
				details: {
					name: '',
					group_admins: [],
					group_members: [],
					channel_name: ''
				}
			}
		}
  },
  computed: {
		...mapGetters({
			members: 'chat/members',
			groups: 'chat/groups',
			myself: 'chat/myself'
		}),

		groupAdmin() {
			return this.currentChat.group_admins.includes(this.myself.id);
		},

		privateGroupOptions() {
			if (this.currentChat.is_private) {
				return this.currentChat.group_admins.includes(this.myself.id);
			}

			return true;
		}
  },
  watch: {
  },
  mounted() {
		this.manageGroup.details = {
			name: this.currentChat.name,
			channel_name: this.currentChat.channel_name,
			group_admins: this.currentChat.group_admins,
			group_members: this.currentChat.group_members
		}

  },
  updated() {
  },
  activated() {
  },
  methods: {
		handleGroupCommands(command){
			this[command]()
		},
		showManageGroup() {
			this.manageGroup.show = true
		},
		deleteValidator(value) {
			if (value == this.currentChat.name){
				return true;
			}
			return 'Name has to match exactly';
		},
		manageGroupDelete() {
			this.$prompt('Please type the name of the group to delete', 'Delete Group', {
				confirmButtonText: 'Delete',
				cancelButtonText: 'Cancel',
				customClass: 'manage-group-delete',
				type: 'error',
				inputValidator: this.deleteValidator,
			}).then(({ value }) => {
				this.deleteGroup();
			}).catch(() => {

			});
		},
		async manage() {
			let group = this.manageGroup.details;
			let remove = _.differenceWith(this.currentChat.group_members.map(member => member.id), group.group_members.map(member => member.id));

			await axios.post(
				`/api/v2/global-messaging-groups/update`,
				{
					name: group.name,
					group_admins: group.group_admins,
					group_members: group.group_members.map(member => member.id),
					detach_members: remove,
					channel_name: group.channel_name
				},
				{
					headers: {
						Authorization: `Bearer ${this.$store.getters.token}`
					}
				}
			).then((res) => {
					let groupIndex = this.groups.findIndex(g => g.channel_name == group.channel_name)
					this.$store.dispatch("chat/updateGroups", {index: groupIndex, group: res.data});
					this.$bus.$emit("chat::groups::update", true);
					this.manageGroup.show = false;
			});
		},

		async deleteGroup() {
			let res = await axios.post(
				`/api/v2/global-messaging-groups/delete`,
				{
					channel_name: this.currentChat.channel_name,
				},
				{
					headers: {
						Authorization: `Bearer ${this.$store.getters.token}`
					}
				}
			).then((res) => {
				let group = this.manageGroup.details;
				let groupIndex = this.groups.findIndex(g => g.channel_name == group.channel_name)
				this.$store.dispatch("chat/removeGroup", groupIndex);
				this.$bus.$emit("chat::groups::update", true);
				this.$bus.$emit("chat::reset::current", true);
			});
		},
  }
}
</script>

<style lang="scss">
	// @import '@assets/sass/backend/_core-variables.scss';
	.el-message-box__wrapper {
			z-index: 20000000!important;
	}
	.group-class {
		max-height: 50vh;
		overflow: hidden;
		overflow-y: scroll;
		text-align: left;

		&::-webkit-scrollbar {
			display:none;
		}
		-ms-overflow-style: none;  /* IE and Edge */
		scrollbar-width: none;  /* Firefox */
	}
</style>
